import React from 'react';

interface OperationsHeaderProps {
    mode: string;
    jointNumber: number;
    isUpdating: boolean;
    lastUpdate: string;
    activeAlarmCount: number;
}

export const OperationsHeader: React.FC<OperationsHeaderProps> = ({
    mode,
    jointNumber,
    isUpdating,
    lastUpdate,
    activeAlarmCount,
}) => {
    return (
        <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <div className={`h-3 w-3 rounded-full ${mode === 'Joint' ? 'bg-red-500' : 'bg-yellow-500'}`}></div>
                    <span className="font-semibold text-gray-900">{mode.toUpperCase()} MODE</span>
                </div>
                <div className="text-sm text-gray-600">
                    Joint #{jointNumber}
                </div>
                <div className="flex items-center gap-2">
                    {isUpdating && (
                        <div className="h-2 w-2 bg-blue-500 rounded-full animate-pulse"></div>
                    )}
                    <span className="text-xs text-gray-500">
                        Last Record Timestamp: {lastUpdate} UTC
                    </span>
                </div>
            </div>
            <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-red-600">
                    {activeAlarmCount} Active Alarms
                </span>
            </div>
        </div>
    );
};

